import React from 'react';
import '../css/McaRegistration.css';

const McaRegistration = () => {
  return (
    <section className="gfi-mca-reg-section">
      <div className="gfi-mca-reg-container">
        <div className="gfi-mca-split-grid">
          
          {/* ==========================================
              LEFT COLUMN: METADATA & COMPLIANCE TEXT
             ========================================== */}
          <div className="gfi-mca-info-block">
            
            <span className="gfi-mca-badge">LEGAL COMPLIANCE</span>
            
            <h2 className="gfi-mca-main-title">Registered & Recognized</h2>
            
            <p className="gfi-mca-description">
              GreenField Academy Pvt. Ltd. is a legally registered entity under the Ministry 
              of Corporate Affairs (MCA), Government of India. Our registration confirms 
              our commitment to providing authentic and recognized educational 
              services in the field of industrial safety.
            </p>

            {/* Structured Checked Legal Parameters List */}
            <div className="gfi-mca-parameters-list">
              
              <div className="gfi-mca-param-row">
                <div className="gfi-mca-check-icon">✓</div>
                <div className="gfi-mca-param-meta">
                  <strong>Company Name:</strong>
                  <span>GreenField Academy Pvt. Ltd.</span>
                </div>
              </div>

              <div className="gfi-mca-param-row">
                <div className="gfi-mca-check-icon">✓</div>
                <div className="gfi-mca-param-meta">
                  <strong>CIN Number:</strong>
                  <span className="gfi-mono-text">U*******R2010PTC****54</span>
                </div>
              </div>

              <div className="gfi-mca-param-row">
                <div className="gfi-mca-check-icon">✓</div>
                <div className="gfi-mca-param-meta">
                  <strong>Registration Date:</strong>
                  <span>Established in 2010</span>
                </div>
              </div>

              <div className="gfi-mca-param-row">
                <div className="gfi-mca-check-icon">✓</div>
                <div className="gfi-mca-param-meta">
                  <strong>Registered Office:</strong>
                  <span>GKP, UP, India</span>
                </div>
              </div>

            </div>

          </div>

          {/* ==========================================
              RIGHT COLUMN: SCAN DOCUMENT PREVIEWER CARD
             ========================================== */}
          <div className="gfi-mca-document-sidebar">
            <div className="gfi-mca-doc-card">
              
              {/* Image Frame Border Outline mimicking image 14_2 */}
              <div className="gfi-mca-scan-wrapper">
                <img 
                  src="https://images.unsplash.com/photo-1568667256549-094345857637?q=80&w=600&auto=format&fit=crop" 
                  alt="MCA Certificate of Incorporation - Growth Academy" 
                  className="gfi-mca-scanned-image"
                />
              </div>

              {/* Document Identity Captions footer array */}
              <div className="gfi-mca-doc-footer">
                <h3 className="gfi-mca-doc-title">Certificate of Incorporation</h3>
                <p className="gfi-mca-doc-caption">Official registration certificate of Growth Academy Pvt. Ltd. under MCA.</p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default McaRegistration;